import { withTranslation } from '@application/i18n/with_translation';

export function VonageEncryptionWarningTitle() {
	return <>{withTranslation('VonageEncryptionWarning.Dialog.Title')}</>;
}
